import { APP_COLOR, FONT_FAMILY } from "../theme";

export const notFoundPageStyles = {
  notFoundPageContainer: {
    height: 150,
    fontFamily: FONT_FAMILY,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
    flexDirection: "column",
    margin: 80,
  } as const,
  goToMainPageButton: {
    backgroundColor: APP_COLOR,
    color: "black",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    fontSize: 16,
  } as const,
  goToMainPageButtonLink: {
    marginTop: 40,
    textDecoration: "none"
  } as const,
  loadingBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  } as const,
  divStyle: {
    height: "200px",
  } as const,
};


export const styles = {
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  } as const,
}